import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AboutUsComponent } from './pages/about-us/about-us.component';
import { LawyersComponent } from './pages/lawyers/lawyers.component';
import { BasicInformationComponent } from './pages/basic-information/basic-information.component';

const routes: Routes = [
  {
    path: '',
    component: AboutUsComponent,
    data: {
      language: 'hr',
      config: {
        en: 'about-us'
      }
    }
  },
  {
    path: 'o-nama',
    component: AboutUsComponent,
    data: {
      language: 'hr',
      config: {
        en: 'about-us'
      }
    }
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    data: {
      language: 'en',
      config: {
        hr: 'o-nama'
      }
    }
  },
  {
    path: 'pravnici',
    component: LawyersComponent,
    data: {
      language: 'hr',
      config: {
        en: 'lawyers'
      }
    }
  },
  {
    path: 'lawyers',
    component: LawyersComponent,
    data: {
      language: 'en',
      config: {
        hr: 'pravnici'
      }
    }
  },
  {
    path: 'osnovni-podaci',
    component: BasicInformationComponent,
    data: {
      language: 'hr',
      config: {
        en: 'general-particulars'
      }
    }
  },
  {
    path: 'general-particulars',
    component: BasicInformationComponent,
    data: {
      language: 'en',
      config: {
        hr: 'osnovni-podaci'
      }
    }
  },
  // redirect all other requests to root page
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts